export default "__VITE_ASSET__DeGNjL7M__"